import errorMessages from '@common/constants/errorMessages';
import { isEmpty, validEmailAddress } from '@common/paymentsUtils/inputValidator';

interface ErrorInterface {
  tenantFirstName?: string;
  tenantLastName?: string;
  emailAddress?: string;
  tenantId?: string;
}

function isFirstNameValid(firstName) {
  if (isEmpty(firstName)) {
    return errorMessages.TENANT_FIRST_NAME_EMPTY;
  }
  return errorMessages.CLEAR_ERROR;
}

function isLastNameValid(lastName) {
  if (isEmpty(lastName)) {
    return errorMessages.TENANT_LAST_NAME_EMPTY;
  }
  return errorMessages.CLEAR_ERROR;
}

const isEmailAddressValid = ({ emailAddress, landlordEmail }) => {
  if (isEmpty(emailAddress)) {
    return errorMessages.TENANT_EMAIL_ADDRESS_EMPTY;
  } else if (!validEmailAddress(emailAddress)) {
    return errorMessages.INVALID_EMAIL_ADDRESS;
  } else if (emailAddress === landlordEmail) {
    return errorMessages.UNIQUE_EMAIL_ADDRESS;
  }
  return errorMessages.CLEAR_ERROR;
};

export function validateAllInputs(ctx) {
  const { tenantFirstName, tenantLastName, emailAddress } = ctx.state;
  const { landlordEmail } = ctx.props;

  const errors: ErrorInterface[] = [];

  const tenantFirstNameError = isFirstNameValid(tenantFirstName.value);
  const tenantLastNameError = isLastNameValid(tenantLastName.value);
  const emailAddressError = isEmailAddressValid({
    emailAddress: emailAddress.value,
    landlordEmail,
  });

  if (tenantFirstNameError) {
    errors.push({ tenantFirstName: tenantFirstNameError });
  }

  if (tenantLastNameError) {
    errors.push({ tenantLastName: tenantLastNameError });
  }

  if (emailAddressError) {
    errors.push({ emailAddress: emailAddressError });
  }

  ctx.setState({
    tenantFirstName: { ...tenantFirstName, error: tenantFirstNameError },
    tenantLastName: { ...tenantLastName, error: tenantLastNameError },
    emailAddress: { ...emailAddress, error: emailAddressError },
  });

  if (errors.length > 0) {
    ctx.props.trackValidationError({ errors });
    return false;
  }

  return true;
}

function isTenantIdValid(tenantId) {
  if (tenantId < 0) {
    return errorMessages.TENANT_NOT_SELECTED;
  }
  return errorMessages.CLEAR_ERROR;
}

export function validateTenantSelected(ctx) {
  const { tenantId } = ctx.state;

  const errors: ErrorInterface[] = [];

  const tenantIdError = isTenantIdValid(tenantId.value);

  if (tenantIdError) {
    errors.push({ tenantId: tenantIdError });
  }

  ctx.setState({
    tenantId: { ...tenantId, error: tenantIdError },
  });

  if (errors.length > 0) {
    ctx.props.trackValidationError({ errors });
    return false;
  }

  return true;
}
